// Resultado del motor: la ausencia de excepción nunca acredita colas vacías.
export function summarizeVisitaSyncCycle({ drafts = [], media = [], operations = [], copiesPending = 0, isCurrent = true, online = true, visitIds = null, transientFailure = false }) {
    const allowed = row => !visitIds || visitIds.includes(Number(row.visitaId));
    const activeOperations = operations.filter(row => allowed(row) && !['applied', 'superseded'].includes(row.status));
    const pending = { drafts: drafts.filter(allowed).length, media: media.filter(allowed).length, operations: activeOperations.length, copies: copiesPending };
    const total = Object.values(pending).reduce((sum, value) => sum + value, 0);
    const blocked = !isCurrent || activeOperations.some(row => ['conflict', 'failed'].includes(row.status));
    return { success: isCurrent && total === 0, complete: isCurrent && total === 0,
        reason: !isCurrent ? 'identity' : total === 0 ? 'complete' : blocked ? 'conflict' : transientFailure ? 'network' : copiesPending > 0 ? 'dependency' : 'pending',
        pending, total, blocked, identityChanged: !isCurrent, offline: !online,
        // Un error de dominio no se reintenta como si fuera una caída de red.
        retryable: isCurrent && total > 0 && !blocked && online && transientFailure };
}

export function assertVisitaSyncIdentity(isCurrent) {
    if (!isCurrent()) throw Object.assign(new Error('Cambió la cuenta. Los pendientes se conservan.'), { code: 'identity_changed' });
}
